import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class AppNavigationComponent {
  public canManageRoles$ = this._authService.user$.pipe(map(user => user.canManageRoles));

  constructor(private readonly _authService: AuthService) {}

  public logout() {
    this._authService.logout();
  }
}
